import { Injectable, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { EventService } from "@spartacus/core";
import { LAUNCH_CALLER } from "@spartacus/storefront";
import { take } from "rxjs/operators";
import { CartAddEntryFailEvent } from "@spartacus/cart/base/root";
import { GenCartUiEventAddToCart } from "src/app/generac/events/product.event";
import { Actions, ofType } from "@ngrx/effects";
import { CartActions } from "../core/store";
import { isLimitedAvailabilityStatus } from "src/app/generac/utils/limited-availability.utils";
import { GenLaunchDialogService } from "src/app/generac/services/launch-dialog.service";

@Injectable({
  providedIn: 'root',
})
export class GenAddedToCartDialogEventListener implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    protected eventService: EventService,
    protected launchDialogService: GenLaunchDialogService,
    protected actions$: Actions,
  ) {
    this.onAddToCart();
  }

  protected onAddToCart() {
    this.subscription.add(
      this.eventService.get(GenCartUiEventAddToCart).subscribe((event) => {
        this.openModal(event);
      })
    );

    this.subscription.add(
      this.eventService.get(CartAddEntryFailEvent).subscribe((event) => {
        this.closeModal(event);
      })
    );

    this.subscription.add(
      this.actions$.pipe(
        ofType(CartActions.GEN_CART_ADD_ENTRY_SUCCESS)
      ).subscribe((action: CartActions.GenCartAddEntrySuccess) => {
        if (isLimitedAvailabilityStatus(action.payload.statusCode)) {
          this.closeModal(action);
        }
      })
    );
  }

  protected openModal(addToCartData: GenCartUiEventAddToCart): void {
    const dialog = this.launchDialogService.openDialog(
      LAUNCH_CALLER.ADDED_TO_CART,
      undefined,
      undefined,
      addToCartData
    );

    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }

  protected closeModal(reason?: any): void {
    this.launchDialogService.closeDialog(reason, LAUNCH_CALLER.ADDED_TO_CART);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
